import req from './request.js'

export function contactInfo(data) {
  return req('get', '/index/index/contactInfo', data)
}